import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="54" height="54" rx="10.8" />
    <path
      d="M13.0001 45V40.4C13.0001 37.4177 15.4178 35 18.4001 35H35.6001C38.5824 35 41.0001 37.4177 41.0001 40.4V45"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.5001 30C33.2991 30 38.0001 25.299 38.0001 19.5C38.0001 13.701 33.2991 9 27.5001 9C21.7011 9 17.0001 13.701 17.0001 19.5C17.0001 25.299 21.7011 30 27.5001 30Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
